import { Fragment } from 'react'
import { TableRow, TableCell } from '@/components/ui/table'
import { Cell, CheckboxWithName } from './PlacementComponents'

const PlatformRow = ({
    platform,
    isChecked,
    isExpanded,
    isIndeterminate,
    handlePlatformToggle,
    handleExpandToggle,
    selectedColumns,
    renderMetricValue,
    getPlatformTotal,
    getMetricValue,
    selectedPlacements,
    handlePlacmentToggle,
}) => {
    return (
        <Fragment key={platform.id}>
            {/* Platform Row */}
            <TableRow
                className="tw:data-[state=selected]:bg-muted tw:!border-b tw:transition-colors hover:tw:bg-gray-700/20 tw:cursor-pointer"
                onClick={() => handlePlatformToggle(platform.id)}
            >
                <Cell
                    isIndeterminate={isIndeterminate}
                    handlePlatformToggle={handlePlatformToggle}
                    platform={platform}
                    isChecked={isChecked}
                    handleExpandToggle={handleExpandToggle}
                    isExpanded={isExpanded}
                />
                {selectedColumns.map((column) => (
                    <TableCell key={column.id} className="tw:text-right tw:text-sm tw:text-white tw:pr-3">
                        {renderMetricValue(getPlatformTotal(column.apiKey, platform), column)}
                    </TableCell>
                ))}
            </TableRow>

            {/* Sub-placement Rows with Animation */}
            {isExpanded &&
                platform.subPlacements.map((placement) => (
                    <TableRow
                        key={placement.id}
                        className="hover:tw:bg-gray-700/20 tw:cursor-pointer tw:animate-in tw:slide-in-from-top-1 tw:duration-200"
                        onClick={() => handlePlacmentToggle(platform.id, placement.id)}
                    >
                        <TableCell className="tw:pl-3">
                            <CheckboxWithName
                                platform={platform}
                                placement={placement}
                                selectedPlacements={selectedPlacements}
                                handlePlacmentToggle={handlePlacmentToggle}
                            />
                        </TableCell>
                        {selectedColumns.map((column) => (
                            <TableCell key={column.id} className="tw:text-right tw:text-sm tw:text-white tw:pr-3">
                                {renderMetricValue(getMetricValue(column.apiKey, platform.id, placement.id), column)}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
        </Fragment>
    )
}

export default PlatformRow
